import isCustomKeyField from "./IsCustomKeyField";

// Gets Value of a Custom Field
function getCustomKey(value: string): string {
  if (isCustomKeyField(value)) {
    return value.slice(value.indexOf("{") + 1, value.indexOf("}"));
  }
  return "";
}

export default getCustomKey;
